


















































































































































import BaseComponent from "@/components/base/BaseComponent";
import {FundType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import i18n from "@/lang/lang";
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {KeyValuePair} from "@payroll/optimus-common";
import {Component, Prop, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";

@Component({
  computed: {}
})
export default class ChangeInvestmentPaths extends BaseComponent {

  @Prop() componentProps!: any;

  @Action('getSecondPartDetailsChangeInvestment', StoreNamespace.PROCESSES_MANAGEMENT) getSecondPartDetailsChangeInvestment: any;

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string;


  dataProps: any = null;
  fundChangeInvestmentModel: any[] = [];
  selectedFundChangeInvestmentModel: any[] = [];
  private selectedOptions: number = 0;
  private totalCurrentDeposits: number = 0;
  private showValidationSuccessMessage: boolean = false;
  private showTotalCurrentDepositsError: boolean = false;
  private showTotalCurrentDepositsOverThen100Error: boolean = false;
  private totalAccumulatedBalance: number = 0;
  private showTotalAccumulatedBalanceError: boolean = false;
  private showTotalAccumulatedBalanceOverThen100Error: boolean = false;
  private showDontChooseError: boolean = false;
  private showCheckBox: boolean = true;
  private showShekelRoute: boolean = false;
  private shekelRouteName: String = "";
  private shekelRouteTimeOptions: KeyValuePair[] = [{value: "6", description: "6"}, {value: "12", description: "12"},
    {value: "24", description: "24"}];
  private shekelRouteTimeSelected: KeyValuePair | null = null
  private shekelRouteOptions: KeyValuePair[] = [];
  private shekelRouteSelected: KeyValuePair | null = null
  private FundType: FundType = FundType.ANY

  private userDetailsFields: any = [

    {key: 'id', label: " "},
    {key: 'optionName', label: i18n.t('changeInvestmentOptions.selectedRoutes')},
    {key: 'financeCode', label: i18n.t('changeInvestmentOptions.confirmationNumberTex')},
    {key: 'accumulatedBalance', label: i18n.t('changeInvestmentOptions.accumulatedBalance')},
    {key: 'currentDeposits', label: i18n.t('changeInvestmentOptions.currentDeposits')},
  ];

  mounted() {
    this.dataProps = {...this.componentProps}; // Initialize dataProps with a copy of componentProps
  }

  @Watch('componentProps', {deep: true})
  handleComponentPropsChanged(newVal: any) {
    this.dataProps = {...newVal};

    if (this.dataProps.accountNum) {
      let formData: FormData = new FormData();
      formData.append("fundType", this.dataProps.fundType)
      formData.append("accountNum", this.dataProps.accountNum)
      this.getSecondPartDetailsChangeInvestment({
        requestorCallback: this,
        formData: formData
      })
    }
  }


  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {

      case 'getSecondPartDetailsChangeInvestment':
        this.fundChangeInvestmentModel = data.fundChangeInvestmentModels;
        break
    }
  }


  private onCheckboxChange(id: any) {
    console.log('here')
    this.selectedOptions = 1;
  }


  private isFirstSelectionChoose(): boolean {
    return this.selectedOptions === 0;
  }

  private onCheckboxInput(id: number) {
    let fundChangeInvestmentModels = this.fundChangeInvestmentModel.filter((current: any) => current.id === id)[0];
    fundChangeInvestmentModels.checked = !fundChangeInvestmentModels.checked;
    this.selectedFundChangeInvestmentModel = this.fundChangeInvestmentModel.filter((current: any) => current.checked === true)

    if (!fundChangeInvestmentModels.checked) {
      fundChangeInvestmentModels.accumulatedBalance = 0;
      fundChangeInvestmentModels.currentDeposits = 0;
      this.onCurrentDepositChange(fundChangeInvestmentModels.id)
      this.onAccumulatedBalanceChange(fundChangeInvestmentModels.id)

      if (fundChangeInvestmentModels.shekelRoute) {
        this.showShekelRoute = false;
      }
    } else {
      console.log("fundChangeInvestmentModels", fundChangeInvestmentModels)

      if (fundChangeInvestmentModels.shekelRoute) {
        this.shekelRouteOptions = this.fundChangeInvestmentModel
            .filter((current: any) => !current.shekelRoute)
            .map((current: any) => {
              return {
                value: current.id.toString(),
                description: current.optionName
              } as KeyValuePair;
            });
        this.showShekelRoute = true;
        this.shekelRouteName = fundChangeInvestmentModels.optionName;
      }
    }
  }

  private onCurrentDepositChange(id: number): void {
    let totalCurrentDeposits = this.fundChangeInvestmentModel
        .filter((current: any) => current.checked)
        .reduce((sum: number, curr: any) => sum + Number(curr.currentDeposits), 0)

    this.showTotalCurrentDepositsError = false;
    this.showTotalCurrentDepositsOverThen100Error = false;
    this.showDontChooseError = false;
    this.totalCurrentDeposits = totalCurrentDeposits;
  }

  private onAccumulatedBalanceChange(id: number): void {
    let totalCurrentDeposits = this.fundChangeInvestmentModel
        .filter((current: any) => current.checked)
        .reduce((sum: number, curr: any) => sum + Number(curr.accumulatedBalance), 0)

    this.showTotalAccumulatedBalanceError = false;
    this.showTotalAccumulatedBalanceOverThen100Error = false;
    this.showDontChooseError = false;
    this.totalAccumulatedBalance = totalCurrentDeposits;
  }

  private showOptionSelected(): boolean {
    return this.dataProps.fundType !== FundType.EDUCATION_FUND &&
        this.dataProps.fundType !== FundType.INVESTMENT_PROVIDENT_FUND &&
        !this.isTaasiaAvirit()
  }

  private isTaasiaAvirit(): boolean {
    return this.mngCompanyName === ManagingCompanies.TAASIA_AVIRIT.toLowerCase()
  }

  private radioGroupSelectionChanged(selected: any) {
    if (selected === 0) {
      this.showCheckBox = false;
      setTimeout(() => this.showCheckBox = true, 1)
      this.selectedFundChangeInvestmentModel = [];
      this.totalAccumulatedBalance = 0;
      this.totalAccumulatedBalance = 0;
      this.totalCurrentDeposits = 0;
      this.totalCurrentDeposits = 0;
      this.fundChangeInvestmentModel.forEach(current => {
        current.checked = false;
        current.currentDeposits = 0;
        current.accumulatedBalance = 0;
      })
    }
  }

  checkUserSelection() {
    this.showValidationSuccessMessage = false


    if (!this.isFirstSelectionChoose()) {
      if (this.totalCurrentDeposits > 0 && this.totalCurrentDeposits < 100) {
        this.showTotalCurrentDepositsError = true;
        return;
      }

      if (this.totalAccumulatedBalance > 0 && this.totalAccumulatedBalance < 100) {
        this.showTotalAccumulatedBalanceError = true;
        return;
      }

      if (this.totalCurrentDeposits > 100) {
        this.showTotalCurrentDepositsOverThen100Error = true;
        return;
      }

      if (this.totalAccumulatedBalance > 100) {
        this.showTotalAccumulatedBalanceOverThen100Error = true;
        return;
      }

      if (this.totalAccumulatedBalance === 0 && this.totalCurrentDeposits === 0) {
        this.showDontChooseError = true;
        return;
      }
    }

    this.showValidationSuccessMessage = true;
    this.updateProcessRequest();
  }

  private updateProcessRequest() {
    let fundNum

    console.log("dataProps", this.dataProps)
    console.log("fundChangeInvestmentModel", this.fundChangeInvestmentModel)

    if (this.dataProps?.showOptionAccountModel) {
      fundNum = this.dataProps?.optionAccounts[0].fundNum;
      let primaryFund = this.dataProps?.optionAccounts.find((account: any) => account.isPrimaryFund);
      if (primaryFund) {
        fundNum = primaryFund.fundNum;
      }
    } else {
      fundNum = this.dataProps?.fundNum;
    }

    const body = {
      totalAccumulatedBalance: this.totalAccumulatedBalance,
      totalCurrentDeposits: this.totalCurrentDeposits,
      selectedOptionsStepTwo: this.selectedOptions,
      shekelRouteTimeSelected: this.shekelRouteTimeSelected,
      shekelRouteSelected: this.shekelRouteSelected,
      accountNumber: this.dataProps!.accountNum,
      primaryFundNum: fundNum,
      hasComposition: this.dataProps!.hasComposition,
      fundType: this.dataProps!.value,
      selectedFundChangeInvestmentModels: this.selectedFundChangeInvestmentModel,
      employerName: this.dataProps!.employerName,
    }

    this.$emit('updateChanges', body)
  }


  get showPathsTable() {
    if (this.showOptionSelected()) {
      this.fundChangeInvestmentModel.length > 0 && this.selectedOptions > 0;
    }

    return this.fundChangeInvestmentModel.length > 0;
  }
}
